/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pleasecheckyourinboxandclickontheverificationlink9Inputs */

const en_pleasecheckyourinboxandclickontheverificationlink9 = /** @type {(inputs: Pleasecheckyourinboxandclickontheverificationlink9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please check your inbox and click on the verification link.`)
};

const de_pleasecheckyourinboxandclickontheverificationlink9 = /** @type {(inputs: Pleasecheckyourinboxandclickontheverificationlink9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schau in dein Postfach und tipp auf den Bestätigungslink.`)
};

/**
* | output |
* | --- |
* | "Please check your inbox and click on the verification link." |
*
* @param {Pleasecheckyourinboxandclickontheverificationlink9Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const pleasecheckyourinboxandclickontheverificationlink9 = /** @type {((inputs?: Pleasecheckyourinboxandclickontheverificationlink9Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pleasecheckyourinboxandclickontheverificationlink9Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pleasecheckyourinboxandclickontheverificationlink9(inputs)
	return de_pleasecheckyourinboxandclickontheverificationlink9(inputs)
});
export { pleasecheckyourinboxandclickontheverificationlink9 as "pleaseCheckYourInboxAndClickOnTheVerificationLink" }